const Links = {
    meeting_booking: "https://outlook.office365.com/owa/calendar/MeetingSynapseHR@biware-consulting.com/bookings/s/xF6ZHPpdUkWQt7KdpMLBcg2",
    synapse_facebook: "https://www.facebook.com/synapsehrapp",
    synapse_linkedin: "https://www.linkedin.com/showcase/synapse-hr/",
    synapse_youtube: "https://www.youtube.com/@synapseapp7899"
}

export default Links